import React from "react";
import Modal from "react-bootstrap/Modal";
import Formulario from "./Formulario";

const ModalComponent = ({
    showModal,
    setShowModal,
    company,
    setMesssage,
    setPaginate,
}) => {
    return (
        <>
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        Editar Empresa
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formulario
                        company={company}
                        setShowModal={setShowModal}
                        setMesssage={setMesssage}
                        setPaginate={setPaginate}
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ModalComponent;
